import type { Tenant } from '@titan/shared';
import { Navigate, useNavigate, useParams } from 'react-router';
import { ScreenBody, ScreenHeader } from '../../shell/Shell.js';
import { EmptyState, InlineError, ListContainer, ListHeader, ListRow, PrimaryCell, RowMeta, RowTitle } from '../../ui/index.js';
import { useLoad } from '../useLoad.js';

/** Roles live in the tenant's access center. Keep the old route working. */
export function TenantRoles() {
  const { id = '' } = useParams();
  return <Navigate to={`/admin/tenants/${id}?tab=roles`} replace />;
}

/** `/admin/roles`: roles live per tenant, so pick one. */
export function RolesPicker() {
  const navigate = useNavigate();
  const { data, error, loading } = useLoad<{ tenants: Tenant[] }>('/admin/tenants');
  return (
    <>
      <ScreenHeader eyebrow="administration · roles and permissions" title="Roles and permissions" description="Every tenant has its own matrix. Choose the tenant to edit." />
      <ScreenBody>
        {error && <InlineError>{error}</InlineError>}
        <ListContainer>
          <ListHeader title="Tenants" />
          {!loading && (data?.tenants.length ?? 0) === 0 && <EmptyState>No tenants yet. Create one first.</EmptyState>}
          {data?.tenants.map((t) => (
            <ListRow
              key={t.id}
              clickable
              center
              onClick={() => navigate(`/admin/tenants/${t.id}?tab=roles`)}
              onKeyDown={(e) => e.key === 'Enter' && navigate(`/admin/tenants/${t.id}?tab=roles`)}
            >
              <PrimaryCell>
                <RowTitle small>{t.name}</RowTitle>
                <RowMeta>
                  {t.plan} · {t.status}
                </RowMeta>
              </PrimaryCell>
            </ListRow>
          ))}
        </ListContainer>
      </ScreenBody>
    </>
  );
}
